import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    { path: '/', redirect: '/index/history' },
    {
      path: '/index',
      name: 'Index',
      redirect: '/index/index',
      component: () => import('@/components/index/Index'),
      children: [
        { // 上传记录
          path: 'history',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'history',
          component: () => import('@/views/index/CopyHis')
        },
        { // 发布商品
          path: 'release',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'release',
          component: () => import('@/views/index/release')
        },
        { // 首页 商品列表
          path: 'goodslist',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'GoodsList',
          component: () => import('@/views/index/GoodsList')
        },
        { // 复制商品
          path: 'copy',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'CopyGoods',
          component: () => import('@/views/index/CopyGoods')
        },
        { // 店铺列表
          path: 'shopList',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'shopList',
          component: () => import('@/views/index/ShopList')
        },
        { // 利润库存配置
          path: 'shopset',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'shopset',
          component: () => import('@/views/index/shopset')
        },
      ]
    },
    {                                                         // 前台登录
      path: '/logreq',
      name: 'logreq',
      component: () => import('@/views/index/LogReq')
    },
    {                                                         // 前台登录
      path: '/login',
      name: 'login',
      component: () => import('@/views/index/Login')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js